import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  connect() {
    this.isVisible = false
  }

  toggle(event) {
    event.preventDefault()
    
    this.isVisible = !this.isVisible
    
    if (this.isVisible) {
      this.inputTarget.type = "text"
      this.iconTarget.classList.remove("ph-eye")
      this.iconTarget.classList.add("ph-eye-slash")
    } else {
      this.inputTarget.type = "password"
      this.iconTarget.classList.remove("ph-eye-slash")
      this.iconTarget.classList.add("ph-eye")
    }
  }
}